import EnumList from './EnumList';

class LoginPageTypes extends EnumList {
  constructor() {
    super();

    this.LOGIN = this.add(0, 'login');
    this.REQUESTPASSWORDRESET = this.add(1, 'request-password-reset');
    this.RESETPASSWORD = this.add(2, 'reset-password');
  }
}

export default LoginPageTypes;


// WEBPACK FOOTER //
// ./src/Stores/DataStore/Enums/LoginPageTypes.js